// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapping-help h1{font-size:1.8rem}.mapping-help h2{font-size:1.4rem}.mapping-help dl{padding-left:15px}.mapping-help dl dd{padding-left:5px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
